import React ,{useEffect} from 'react';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import LocalGroceryStoreIcon from '@material-ui/icons/LocalGroceryStore';
//import WysiwygIcon from '@mui/icons-material/Wysiwyg';
//import messages, {MessageData} from '../../services/db/messages/messages';
// import {makeStyles} from '@material-ui/core';
//import MessageItem from './MessageItem';
import Popover from '@material-ui/core/Popover';
import List from '@material-ui/core/List';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Scrollbar from '../Scrollbar';
import IntlMessages from '../../utility/IntlMessages';
import Hidden from '@material-ui/core/Hidden';
import clsx from 'clsx';
import {Fonts} from '../../../shared/constants/AppEnums';
//import {CremaTheme} from '../../../types/AppContextPropsType';

import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {AppState} from '../../../redux/store';
import {getCartItems} from '../../../redux/actions/Ecommerce';
import CartTableItem from '../../../modules/ecommerce/Carts/CartTable/CartTableItem';
import useStyles from '../AppLayout/Standard/AppHeader.style';  
import {CartItems} from '../../../types/models/ecommerce/EcommerceApp';

interface HeaderMessagesProps {}

const HeaderMessages: React.FC<HeaderMessagesProps> = () => {
  const [
    anchorMessages,
    setAnchorMessages,
  ] = React.useState<HTMLButtonElement | null>(null);

  const onClickCartButton = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    setAnchorMessages(event.currentTarget);
  };

  const classes = useStyles();

  const dispatch = useDispatch();
  const history = useHistory();

  const {cartItems} = useSelector<AppState, AppState['ecommerce']>(
    ({ecommerce}) => ecommerce,
  );

  const getThreeItems = (cartItems: CartItems[]) =>{
    return cartItems.slice(0,3);
  }

  const getCartCount = () =>{
    let cartCount:number = 0;
    for(let count=0; count< cartItems.length; count++)
    {
      cartCount = cartCount + cartItems[count].count;
    }
    return cartCount;
  }

  useEffect(() => {
    dispatch(getCartItems());
  }, [dispatch]);

  return (
    <>
      <IconButton
        className={clsx(classes.notiBtn, 'notiBtn')}
        aria-label='show 4 new mails'
        color='inherit'
        onClick={onClickCartButton}>
        <Badge
          className={classes.badgeStyle}
          badgeContent={getCartCount()}
          color='secondary'>
          <LocalGroceryStoreIcon className={clsx(classes.materialUiIcon, 'LocalGroceryStoreIcon')} />
        </Badge>
        <Hidden mdUp>
          <Box
            ml={2}
            fontSize={16}
            fontFamily='Montserrat'
            fontWeight={Fonts.REGULAR}
            component='span'>
            <IntlMessages id='sidebar.ecommerce.cart' />
          </Box>
        </Hidden>
      </IconButton>

      <Popover
        anchorEl={anchorMessages}
        id='app-message'
        //className={classes.crPopover} //this is the style of cart container size
        open={Boolean(anchorMessages)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        onClose={() => setAnchorMessages(null)}>
        <Box>
          <Box px={5} py={3}>
          {/* Only cart have item, then show View all and cart list */}
          {cartItems.length>0 ?
            <Box component='h5' fontWeight={Fonts.MEDIUM}>
              <IntlMessages id='sidebar.ecommerce.cart' />({getCartCount()})
            </Box>
            : <Box component='h5' fontWeight={Fonts.MEDIUM}>Your cart is empty.</Box>
          }
          </Box>

          {cartItems.length>0 ?
          <Scrollbar className='scroll-submenu'>
            <List
              className={classes.listRoot}
              onClick={() => {
                setAnchorMessages(null);
              }}>
              {getThreeItems(cartItems).map(data => (
                <CartTableItem data={data} key={data.ProductCode} />
              ))}
              {cartItems.length>3?
                 <Box
                 mb={2}
                 mt={2}
                 display='flex'
                 flexDirection={{xs: 'row', sm: 'row'}}
                 alignItems='center'
                 justifyContent='center'
                 > More items in cart ... 
                </Box>
              :null}
            </List>
          </Scrollbar>
          : null }

          {cartItems.length>0 ?
          <Box
            mb={2}
            display='flex'
            flexDirection={{xs: 'row', sm: 'row'}}
            alignItems='center'
            justifyContent='center'
            >
            <Button
              variant='contained'
              color='primary'
              size='small'
              onClick={() => {
                setAnchorMessages(null); //hide cart details after click view all
                history.push('/ecommerce/cart');
              }}
              className={classes.btnRoot}>
              <IntlMessages id='common.viewAll' />
            </Button>
          </Box>
          :null}
         </Box>
      </Popover>
    </>
  );
};

export default HeaderMessages;
